export const REF_NAME = 'OWNER';
export const REF_PATH = 'owner';
export const NAME = 'Ship owner';
